/**
 * Smart Link Prefetcher — Mamapachita
 * Phase 2 cache optimization
 *
 * Pre-fetches internal pages on hover/touchstart so they load
 * near-instantly when clicked. Uses <link rel="prefetch"> which
 * has lowest network priority and won't compete with critical assets.
 *
 * Skips: external links, anchors, already-prefetched URLs, and
 * URLs with query strings (to avoid prefetching faceted/filtered pages).
 *
 * Self-limits to 10 prefetches per session to conserve bandwidth.
 */
(function () {
  'use strict';

  var prefetched = {};
  var count = 0;
  var MAX_PREFETCHES = 10;
  var HOVER_DELAY = 65; /* ms — avoids prefetching on accidental hover */

  function shouldPrefetch(url) {
    if (count >= MAX_PREFETCHES) return false;
    if (prefetched[url]) return false;
    if (!url || url.indexOf(location.origin) !== 0) return false;
    if (url === location.href) return false;
    if (url.indexOf('?') !== -1) return false;
    if (url.indexOf('#') !== -1 && url.split('#')[0] === location.href.split('#')[0]) return false;
    return true;
  }

  function prefetch(url) {
    if (!shouldPrefetch(url)) return;
    prefetched[url] = true;
    count++;

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  var hoverTimer = null;

  document.addEventListener('mouseover', function (e) {
    var anchor = e.target.closest('a[href]');
    if (!anchor) return;

    var href = anchor.href;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      prefetch(href);
    }, HOVER_DELAY);
  }, { passive: true });

  document.addEventListener('mouseout', function () {
    clearTimeout(hoverTimer);
  }, { passive: true });

  /* Touchstart — prefetch immediately for mobile (touch is intentional) */
  document.addEventListener('touchstart', function (e) {
    var anchor = e.target.closest('a[href]');
    if (anchor) prefetch(anchor.href);
  }, { passive: true });
})();
